var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "changeDirection flex flex-row gap-4 items-top customContainer justify-flex-start items-center pr-6 w-max-content",
    },
    [
      [
        _c(
          "div",
          {
            staticClass:
              "flex flex-row justify-flex-start items-flex-start gap-4",
          },
          [
            _c("FormGroup", {
              attrs: {
                type: "search",
                debounceTime: _vm.inputDebounceTime,
                placeholder: "Enter Job title",
                iconStyle: "customIcon",
                inputClass: "customFormInput",
                isIcon: _vm.yes,
              },
              model: {
                value: _vm.jobTitle,
                callback: function ($$v) {
                  _vm.jobTitle = $$v
                },
                expression: "jobTitle",
              },
            }),
            _c(
              "FormGroup",
              [
                _c("SkillsMultiselect", {
                  attrs: { getcontainerStyle: "smallHeight" },
                  model: {
                    value: _vm.skillsIds,
                    callback: function ($$v) {
                      _vm.skillsIds = $$v
                    },
                    expression: "skillsIds",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              [
                _c("CustomRequestStatusMultiselect", {
                  attrs: {
                    placeholder: "Status",
                    getcontainerStyle: "smallHeight",
                  },
                  model: {
                    value: _vm.statusIds,
                    callback: function ($$v) {
                      _vm.statusIds = $$v
                    },
                    expression: "statusIds",
                  },
                }),
              ],
              1
            ),
            _vm.showManagerFilter
              ? _c(
                  "FormGroup",
                  [
                    _c("ManagersMultiselect", {
                      attrs: { getParentcontainerStyle: "smallHeight" },
                      model: {
                        value: _vm.managerIds,
                        callback: function ($$v) {
                          _vm.managerIds = $$v
                        },
                        expression: "managerIds",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c("UiButtonMessage", {
              attrs: {
                buttonClass: "customAdd",
                buttonText: "Reset",
                textClass: "customText customOnlyText",
              },
              on: { click: _vm.handleReset },
            }),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }